import { useContext, useEffect, useState, useCallback, useRef } from "react";
import { UNSAFE_NavigationContext } from "react-router-dom";

type BlockerNavigator = {
  push: (...args: any[]) => void;
  replace: (...args: any[]) => void;
};

export function useNavigationBlocker(when: boolean) {
  const { navigator } = useContext(UNSAFE_NavigationContext) as {
    navigator: BlockerNavigator;
  };
  const [showPrompt, setShowPrompt] = useState(false);
  const pendingAction = useRef<(() => void) | null>(null);

  useEffect(() => {
    if (!when) return;

    const originalPush = navigator.push;
    const originalReplace = navigator.replace;

    navigator.push = (...args: any[]) => {
      pendingAction.current = () => originalPush.apply(navigator, args);
      setShowPrompt(true);
    };

    navigator.replace = (...args: any[]) => {
      pendingAction.current = () => originalReplace.apply(navigator, args);
      setShowPrompt(true);
    };

    return () => {
      navigator.push = originalPush;
      navigator.replace = originalReplace;
    };
  }, [when, navigator]);

  const confirmNavigation = useCallback(() => {
    setShowPrompt(false);
    pendingAction.current?.();
    pendingAction.current = null;
  }, []);

  const cancelNavigation = useCallback(() => {
    setShowPrompt(false);
    pendingAction.current = null;
  }, []);

  return { showPrompt, confirmNavigation, cancelNavigation };
}